import { t } from 'src/viewLayer/helpers/translations';
import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { trackInvalidInput } from 'src/dataLayer/remoteData/babbelEventStream';
import type { ResetErrorMessages, SetErrorMessages, SetErrorMessagesFromBackend } from './types';

export const isReportingEnv = (): boolean => ['staging', 'production'].includes(RUNTIME_ENVIRONMENT);

export const setErrorMessagesFromBackend: SetErrorMessagesFromBackend = (
  errorMessages,
  errorInterface,
  trackingInfo,
  learn_language_alpha3
) => {
  for (const message of errorMessages) {
    const inputName = message.attribute;
    const errorMessage = message.message[0];

    trackInvalidInput({
      learnLang: learn_language_alpha3,
      flowId: trackingInfo.flowId,
      flowVersion: trackingInfo.flowVersion,
      inputName,
      errorMessage
    });
    errorInterface[inputName](errorMessage);
  }
};

// By default, this function sets a default error message for all nodeInputs when the backend returns an error with no
// information.
export const setErrorMessages: SetErrorMessages = (nodeInputs, errorInterface, message = t('error.backend')) => {
  for (const input of nodeInputs) {
    errorInterface[input](message);
  }
};

export const resetErrorMessages: ResetErrorMessages = (nodeInputs, errorInterface) => { setErrorMessages(nodeInputs, errorInterface, ''); };
